import { computed } from 'vue';
import Skeleton from '../../components/skeleton/component-lib.esm.js';
import { SkeletonProps } from '../../components/skeleton/component-lib.esm2.js';

//
var script = {
  components: {
    Skeleton
  },
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: SkeletonProps.color.default
    }
  },
  setup(props) {
    const height = computed(() => {
      switch (props.size) {
        case 'large':
          return '75px';
        default:
          return '57px';
      }
    });
    return {
      height
    };
  }
};
export { script as default };